import { createUseStyles } from 'react-jss';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { TextColors } from '@picsart/design-system/foundation/textColors';
import { PrimaryColors } from '@picsart/design-system/foundation/primaryColors';
import { BREAKPOINTS } from '@/styles/theme';

const useStyles = createUseStyles(
  {
    // View controls - mobile only, shown on library screen
    viewControls: {
      display: 'flex',
      alignItems: 'center',
      gap: 4,
      [`@media (min-width: ${BREAKPOINTS.desktop}px)`]: {
        display: 'none',
      },
    },
    viewOptionButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      padding: 0,
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: CornerRadius.r8,
      cursor: 'pointer',
      color: TextColors.tint1,
      transition: 'color 0.15s ease, background-color 0.15s ease',
      '&:hover': {
        color: TextColors.base,
        backgroundColor: BackgroundColors.tint1,
      },
    },
    viewOptionButtonActive: {
      color: PrimaryColors.base.default,
      backgroundColor: BackgroundColors.tint1,
    },
    viewOptionIcon: {
      width: 18,
      height: 18,
    },
  },
  { name: 'view-controls' }
);

export default useStyles;
